module.exports = __webpack_public_path__ + "static/media/he.d47f60b6.svg";